import { httpRequest } from '@/utils/HttpRequest'
import { ciHttpRequest } from "@/utils/CiHttpRequest";
import { CIPage } from "@/types/FmsTypes";
import {
	IMaintenanceDetail,
	IItemDetailList,
	ThreeGuaranteesItemDetailList,
	IMaterialDetailList,
	OtherItemDetailList
} from './MaintenanceType';

class MaintenanceService {

	async one(id: string) {
		const apiUrl = `/ci/order/platform_one/${id}`;
		return await ciHttpRequest.post<IMaintenanceDetail>(apiUrl, {})
	}

	async itemList(param: any) {
		const apiUrl = `/ci/order/item/list`;
		return await ciHttpRequest.post<CIPage<IItemDetailList>>(apiUrl, param)
	}

	async threeGuaranteesList(param: any) {
		const apiUrl = `/ci/order_three_guarantees/list`;
		return await ciHttpRequest.post<CIPage<ThreeGuaranteesItemDetailList>>(apiUrl, param)
	}

	async materialList(param: any) {
		const apiUrl = `/ci/order/maintan-material/list`;
		return await ciHttpRequest.post<CIPage<IMaterialDetailList>>(apiUrl, param)
	}

	async otherItemDetailList(param: any) {
		const apiUrl = `/ci/order/other-item/list`;
		return await ciHttpRequest.post<CIPage<OtherItemDetailList>>(apiUrl, param)
	}

	//云创订单图片
	async ciOrderImg(searchVo: any) {
		const apiUrl = `/ci/order/attachment/list_for_group`
		return await ciHttpRequest.post<any>(apiUrl, searchVo)
	}
	//云创订单类别
	async ciImageClassifyList(searchVo: any) {
		const apiUrl = `/ci/order/image_classification/list`
		return await ciHttpRequest.post<any>(apiUrl, searchVo)
	}

}
export const maintenanceService = new MaintenanceService();
